import Events from '@blaze-cms/core-events';
import getLogger from '@blaze-cms/core-logger';
import pluginManager from '@blaze-cms/core-plugins';
import getBlazeConfig from '@blaze-cms/utils/src/config/get-blaze-config';
import routesHandler from './utils/routes';
import apolloHandler from './utils/apollo/handler';
import getApolloLogMiddleware from './utils/apollo/log-middleware';
import simpleId from './utils/simple-id';
import getOpenQueryChecker from './utils/apollo/get-open-query-checker';
const INIT_NOT_STARTED = 'not started';
const INIT_STARTED = 'started';
const INIT_COMPLETE = 'complete';
const defaultRootPath = `${__dirname}/../`;
const useAppAsSingleton = process.env.BLAZE_CORE_UI_USE_APP_AS_SINGLETON || true;
const getConfig = (configDir, configOptions) => getBlazeConfig(defaultRootPath)(configDir, configOptions);
function getAppHandler() {
  let currentApp;
  function setApp(app) {
    currentApp = app;
  }
  function getApp() {
    return currentApp;
  }
  return {
    setApp,
    getApp
  };
}
function getBlazeUi(options = {}) {
  let initStatus = INIT_NOT_STARTED;
  const {
    configOptions = {}
  } = options;
  const {
    ctx = {},
    events = new Events(),
    getPluginManager = pluginManager,
    config = getConfig(options.configDir, configOptions),
    logNameSpace = simpleId(),
    log = getLogger(logNameSpace),
    useAsSingleton = useAppAsSingleton
  } = options;
  let layoutComponent;
  const {
    getAll: getRoutes,
    get: getRoute,
    add: addRoute
  } = routesHandler();
  const {
    getQueryResolver,
    getMutationResolver,
    getResolvers,
    addQueryResolver,
    addMutationResolver,
    getProvider,
    getProviderProps,
    addProviderProps,
    createClient: createApolloClient,
    getClient,
    addMiddleware,
    getAllMiddleware,
    loadEntities,
    getProcessedEntities
  } = apolloHandler(config);
  function createClient(initialState, processedEntities) {
    return createApolloClient(initialState, processedEntities);
  }
  function setLayout(component) {
    layoutComponent = component;
  }
  function getLayout() {
    return layoutComponent;
  }
  function initComplete() {
    return initStatus === INIT_COMPLETE;
  }
  const openQueryChecker = getOpenQueryChecker();
  const app = {
    ctx,
    getRoutes,
    getRoute,
    addRoute,
    events,
    log,
    init,
    config,
    setLayout,
    getLayout,
    getProvider,
    getProviderProps,
    addProviderProps,
    getQueryResolver,
    getMutationResolver,
    getResolvers,
    addQueryResolver,
    addMutationResolver,
    createClient,
    getClient,
    addMiddleware,
    getAllMiddleware,
    initComplete,
    getProcessedEntities,
    openQueryChecker
  };
  app.plugins = getPluginManager(app);
  addMiddleware(getApolloLogMiddleware(log.debug.extend('apollo'), openQueryChecker));
  let initPromise;
  async function init() {
    if (initStatus !== INIT_NOT_STARTED) {
      app.log.debug('App init already started');
      return initPromise;
    }
    initPromise = new Promise(resolve => {
      app.log.debug('App init starting');
      initStatus = INIT_STARTED;
      app.plugins.loadPlugins(config.plugins).then(async () => {
        await loadEntities();
        initStatus = INIT_COMPLETE;
        app.log.debug('App init complete');
        resolve();
      });
    });
    return initPromise;
  }
  if (useAsSingleton) {
    appHandler.setApp(app);
  }
  return app;
}
const appHandler = getAppHandler();
export { appHandler };
export default getBlazeUi;
//# sourceMappingURL=index.js.map